import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
Vue.use(Vuex);
// import {requestUnreadCount019 } from '../api/api';
// 应用初始状态
const state = {
    msgCount: 0
}

// 定义所需的 mutations
const mutations = {
    INCREMENT(state) {
        var user = localStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            // requestUnreadCount019({userId: user.id}).then(res => {
            //     if (res.status == 200) {
            //         let data = res.data;
            //         state.msgCount = data;
            //     } else {
            //         state.msgCount = 0;
            //     }
            // });
        }
    }
}

// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js